import { useQuery } from 'react-query';
import { EXPRESS_API } from 'configs/api/expressApi';
import { useToastError } from 'lib/hooks';
import { youtubeKeys } from './queryKeys';

export const queryYoutubeIntegrationStatus = async () => {
  const response = await EXPRESS_API.get('/youtube/integration');
  return response.data;
};

export const useQueryYoutubeIntegrationStatus = () => {
  const { showError } = useToastError();
  return useQuery(
    youtubeKeys.youtube_integration_status(),
    () => queryYoutubeIntegrationStatus(),
    {
      onError: showError,
      refetchOnMount: true,
    }
  );
};
